import "./cta.css";

const CTA = () => {
  return (
    <div className="gpt3__cta">
      <div className="gpt3__cta-content">
        <p>request early access to get started</p>
        <h3>register today & start exploring the endless possibilities.</h3>
      </div>
      <div className="gpt3__cta-btn">
        <button type="button">get started</button>
      </div>
    </div>
  );
};

export default CTA;
